



























import LoadingCircle from '@/components/LoadingCircle.vue';
import Modal from '@/components/mixins/Modal';

export default Modal.extend({
    components: {
        LoadingCircle,
    },
});
